import { glossary } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function CommunitySection() {
  return (
    <section id="community" className="w-full bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="同人术语"
          title="读同人前，先认几个圈内词"
          desc="同人圈的很多说法有约定俗成的含义，理解它们能让你更快看懂标签与简介。下面整理了常见的术语，按出现频率排列，初次接触这类创作时尤其有用。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {glossary.map((g) => (
            <div
              key={g.term}
              className="rounded-lg bg-background-50 border border-background-200/70 p-4 md:p-5"
            >
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-price-tag-3-line text-primary-500"></i>
                {g.term}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{g.def}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-lg bg-secondary-50 border border-secondary-200/70 p-5 md:p-7 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
          <span className="shrink-0 w-14 h-14 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center">
            <i className="ri-lightbulb-flash-line text-2xl"></i>
          </span>
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              给新读者的一个小建议
            </h3>
            <p className="mt-2 text-sm text-secondary-900 leading-relaxed">
              标签只是参考，同一部作品可能同时属于多个类型。遇到拿不准的条目，先读它前一两话，往往比反复研究标签更省时间。遇到陌生的术语，随时回到本节对照查看。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}